// extracted by mini-css-extract-plugin
export default {"ratingDots":"rating_dots-module___ratingDots___c913c3ed"};